import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import { type GameViewModel } from '../../resources/js/typings/viewModels/gameViewModel';
import type GoogleAnalyticsViewModel from '../../resources/js/typings/viewModels/googleAnalyticsViewModel';
import type ArticleCategoryViewModel from '../../resources/js/typings/viewModels/articleCategoryViewModel';
import type PageOfArticlePreviewsViewModel from '../../resources/js/typings/viewModels/pageOfArticlePreviewsViewModel';
import type CmsNavigationViewModel from '../../resources/js/typings/viewModels/cmsNavigationViewModel';
import getCommonViewModels from './getCommonViewModels';
import { type ArchonHeaderViewModel } from '../components/ArchonHeader/ArchonHeader';
import { type ArchonFooterViewModel } from '../components/ArchonFooter/ArchonFooter';

async function getArticleCategoryPageViewModels(
  articleCategorySlug: string,
  pageNumber: number,
  gameSlug: string,
): Promise<{
  googleAnalytics: GoogleAnalyticsViewModel;
  game: GameViewModel;
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
  articleCategory: ArticleCategoryViewModel;
  cmsNavigation: CmsNavigationViewModel;
  pageOfArticlePreviews: PageOfArticlePreviewsViewModel;
}> {
  const data = await fetchJsonFromRpgLogsApi({
    query: `query($articleCategorySlug: String!, $pageNumber: Int!) {
      viewModels {
        game
        articleCategory(
          articleCategorySlug: $articleCategorySlug,
        )
        cmsNavigation(
          currentSlug: $articleCategorySlug,
        )
        pageOfArticlePreviews(
          articleCategorySlug: $articleCategorySlug,
          pageNumber: $pageNumber
        )
      }
    }`,
    variables: {
      articleCategorySlug,
      pageNumber,
    },
    gameSlug,
  });

  return {
    ...(await getCommonViewModels(gameSlug)),
    ...data.viewModels,
  };
}

export default getArticleCategoryPageViewModels;
